/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InsertFileFormatDto { 
    /**
     * the original filename
     */
    name?: string;
    /**
     * format file name, unique for the aspect-ratio
     */
    fileNameRef?: string;
    mimetype?: string;
    assetMedium?: string;
    audioFile?: string;
    size?: number;
    /**
     * Extension of file
     */
    ext?: string;
    /**
     * Name of fallback image in case of banner html asset
     */
    fallbackImg?: string;
    metadata?: object;
}

